import { Component, Input, OnInit } from '@angular/core';
import { Property } from '@app/shared/services/properties/properties.service';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-payouts',
  templateUrl: './property-detail-payouts.component.html',
  styleUrls: ['./property-detail-payouts.component.scss'],
})
export class PropertyDetailPayoutsComponent implements OnInit {
  @Input() property: Property;

  saveStatus: number = 0;

  accounts = [
    {
      merchant: 'stripe',
      nickname: 'Stripe: ben@hospitable.com',
    },
    {
      merchant: 'stripe',
      nickname: 'Stripe: sam@hospitable.com',
    },
  ];

  constructor() { }

  ngOnInit(): void { }
}
